import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { SignatureDishes } from "./components/SignatureDishes";
import { ExperienceSection } from "./components/ExperienceSection";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { MenuPreview } from "./components/MenuPreview";
import { FullMenu } from "./components/FullMenu";
import { BuildYourGrill } from "./components/BuildYourGrill";
import { CateringEvents } from "./components/CateringEvents";
import { Gallery } from "./components/Gallery";
import { SocialMedia } from "./components/SocialMedia";
import { Testimonials } from "./components/Testimonials";
import { GoogleReviews } from "./components/GoogleReviews";
import { LocationContact } from "./components/LocationContact";
import { FinalCTA } from "./components/FinalCTA";
import { FloatingCallButton } from "./components/FloatingCallButton";
import { Footer } from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-white min-h-screen" data-testid="app-container">
        <Header />
        <main role="main" aria-label="Main content">
          <HeroSection />
          <SignatureDishes />
          <ExperienceSection />
          <WhyChooseUs />
          <MenuPreview />
          <FullMenu />
          <BuildYourGrill />
          <CateringEvents />
          <Gallery />
          <SocialMedia />
          <GoogleReviews />
          <Testimonials />
          <LocationContact />
          <FinalCTA />
        </main>
        <Footer />
        <FloatingCallButton />
      </div>
    </LanguageProvider>
  );
}

export default App;
